<template>
  <section class="address-comparison">
    <div class="comparison-heading">
      <strong>{{ $t('orderLogAddress.comparison') }}</strong>
      <el-tag :type="tagType(record.receiveAddressCheckResult)">{{ resultLabel }}</el-tag>
    </div>
    <div class="addresses">
      <div class="address">
        <h3>{{ $t('orderLogAddress.before') }}</h3>
        <p><span>{{ $t('collectionCenter.receivingState') }}</span><b>{{ record.originalReceiveState || '—' }}</b></p>
        <p><span>{{ $t('collectionCenter.receivingCity') }}</span><b>{{ record.originalReceiveCity || '—' }}</b></p>
      </div>
      <i class="el-icon-right" aria-hidden="true" />
      <div class="address" :class="{ after: hasCheckedAddress }">
        <h3>{{ $t(hasCheckedAddress ? 'orderLogAddress.after' : 'orderLogAddress.loggedAddress') }}</h3>
        <p><span>{{ $t('collectionCenter.receivingState') }}</span><b :class="{ changed: stateChanged }">{{ record.receiveState || '—' }}</b></p>
        <p><span>{{ $t('collectionCenter.receivingCity') }}</span><b :class="{ changed: cityChanged }">{{ record.receiveCity || '—' }}</b></p>
      </div>
    </div>
    <p class="comparison-note">{{ $t(noteKey) }}</p>
  </section>
</template>
<script>
import { ADDRESS_CHECK_RESULTS, addressCheckLabel, addressCheckTagType } from './orderLogQuery';
export default {
  name: 'ReceiveAddressComparison',
  props: { record: { type: Object, required: true }},
  computed: {
    resultLabel() { return addressCheckLabel(this.record.receiveAddressCheckResult, (key) => this.$t(key)); },
    noteKey() {
      const result = this.record.receiveAddressCheckResult;
      if (!result) return 'orderLogAddress.legacyNote';
      if (!Object.values(ADDRESS_CHECK_RESULTS).includes(result)) return 'orderLogAddress.unknownNote';
      return result === ADDRESS_CHECK_RESULTS.CORRECTED ? 'orderLogAddress.correctionNote' : `orderLogAddress.${result}_note`;
    },
    hasCheckedAddress() {
      return [ADDRESS_CHECK_RESULTS.CORRECTED, ADDRESS_CHECK_RESULTS.NORMALIZED,
        ADDRESS_CHECK_RESULTS.UNCHANGED].includes(this.record.receiveAddressCheckResult);
    },
    stateChanged() {
      return this.hasCheckedAddress && this.record.originalReceiveState != null &&
        this.record.originalReceiveState !== this.record.receiveState;
    },
    cityChanged() {
      return this.hasCheckedAddress && this.record.originalReceiveCity != null &&
        this.record.originalReceiveCity !== this.record.receiveCity;
    }
  },
  methods: { tagType: addressCheckTagType }
};
</script>
<style scoped>
.address-comparison { margin-bottom: 24px; line-height: 1.5; }
.comparison-heading { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.addresses { display: grid; grid-template-columns: 1fr 24px 1fr; align-items: center; gap: 8px; }
.address { align-self: stretch; border: 1px solid #e5e6eb; border-radius: 6px; padding: 14px; }
.address.after { background: #f2fbf6; border-color: #b6dcc9; }
.address h3 { color: #657180; font-size: 13px; font-weight: 500; margin: 0 0 14px; }
.address p { display: flex; gap: 14px; margin: 10px 0; }
.address p span { flex-shrink: 0; color: #657180; }
.address b { font-weight: 500; overflow-wrap: anywhere; white-space: pre-wrap; }
.address b.changed { color: #a5560b; font-weight: 600; }
.comparison-note { font-size: 13px; color: #657180; margin: 12px 0 0; }
@media (max-width: 1100px) {
  .addresses { grid-template-columns: 1fr; }
  .addresses > i { text-align: center; transform: rotate(90deg); }
}
</style>
